import { siteNav } from "@/mocks/anime";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-lg">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-semibold">91动漫</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-xl">
              91动漫是一个以动漫推荐与排行榜为核心的内容页面，整理热门番剧、新番推荐与好看动漫分类，
              帮助不同口味的观众快速找到值得追的动画作品。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-100/60 max-w-xl">
              本站内容为编辑整理与主观推荐，评分与排名仅供选番参考，不代表任何官方数据。
              作品中涉及的版权归各自权利人所有，观看请选择正版授权渠道。
            </p>
          </div>

          <div>
            <p className="text-xs font-medium text-background-100/60 mb-3">页面导航</p>
            <ul className="flex flex-col gap-2">
              {siteNav.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-100/85 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">© 2026 91动漫 · 动漫推荐与排行榜内容页</p>
          <p className="text-xs text-background-100/60 flex items-center gap-1.5">
            <i className="ri-information-line" />
            数据为编辑整理，仅供娱乐参考
          </p>
        </div>
      </div>
    </footer>
  );
}